export default __webpack_public_path__ + "static/media/pantry1-afterC-1920w.6b1736b7.avif";